import styled from 'styled-components';

export const StyledSelect = styled.select`
    appearance: 'none';
    background: transparent;
    color: ${(props) => (props.color === 'grayish' ? '#999' : 'whitesmoke')};
    z-index: 1;
    text-shadow: 1px 1px black;
    border: 0;
    outline: 0;
    font-size: 1.4em;
    `;

export const DropDownBars = styled('div')`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display:flex;
    flex-direction: row;
    `;

export const DropDownContainer = styled('div')`
    min-width: 110px;
    display:flex;
    flex-direction: column;
    `;

export const DropDownHeader = styled('div')`    
    padding: 0 .2em;
    /* width: 110px; */
    justify-content: space-between;
    background: transparent;
    color: ${(props) => (props.color === 'grayish' ? '#999' : 'whitesmoke')};
    z-index: 1;
    text-shadow: 1px 1px black;
    border: 0;
    outline: 0;
    font-size: 1.3em;
    cursor: pointer;
    z-index: 1;
    display: flex ;
    flex-flow: row nowrap;
    `;

export const DropDownListContainer = styled('div')`
    width: 100%;
    position: relative;
    display: inline-block;
    display:flex;
    flex-direction: row;
    z-index: 2;
    font-weight: 300;
    font-size: .9em;
    `;

export const DropDownList = styled('ul')`
    padding: 0 0.2em;
    background: black;
    box-sizing: border-box;
    z-index: 1;
    list-style: none;
    padding: 0;
    margin: 0;
    `;

export const ListItem = styled('li')`
    list-style: none;
    background: black;
    z-index: 2;
    text-shadow: 1px 1px black;
    border: 0;
    outline: 0;
    font-size: 1.4em;
    cursor: pointer;
    border: 0.2px solid gray;
    padding: 0 0.8em 0 0.2em;

    &:hover {
      color: 'black';
      background: #999 ;
    }
    `;
